(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
  const body = document.querySelector("body");

  function getHeaderHeight() {
    const headerGroup = document.querySelectorAll(
      "#shopify-section-header, #shopify-section-announcement-banner"
    );
    return [...headerGroup].reduce((total, el) => total + el.offsetHeight, 0);
  }

  function setHeaderHeight() {
    body.style.setProperty("--height-header-group", `${getHeaderHeight()}px`);
  }

  const dropdowns = document.querySelectorAll(".desktop-navigation .site-nav__dropdown");
  const overlays = document.querySelectorAll(".desktop-navigation .dropdown-overlay");

  function setOverlayHeights() {
    overlays.forEach((overlay, index) => {
      const dropdown = dropdowns[index];
      if (dropdown) {
        const dropdownHeight = `${dropdown.offsetHeight + 60}px`;
        overlay.style.setProperty("--height-overlay", dropdownHeight);
      }
    });
  }

  function setStyles() {
    setHeaderHeight();
    setOverlayHeights();
  }

  setStyles();

  window.addEventListener("resize", setStyles);
  });

  } catch(e) { console.error(e); }
})();
})();
